export default "__VITE_ASSET__DJRlOSyc__"